<template>
    <v-snackbar
        v-model="show"
        bottom
        :color="snack.color"
        :timeout="snack.timeout"
        :max-width="this.$vuetify.breakpoint.mdAndUp ? '700px' : ''"
        class="pb-md-2"
        vertical
    >
        <template v-slot:action />
        <v-btn
            dark
            text
            class="float-right ma-0 pa-0"
            @click.native="show = false">
            <v-icon>close</v-icon>
        </v-btn>
        <div
            class="pa-md-2 text-center"
            :class="this.$vuetify.breakpoint.mdAndUp ? 'largerSnackBar' : 'normalSnackBar'"
            role="alert"
            tabindex="0"
            aria-hidden="false"
            aria-live="assertive"
            :aria-label="snack.message"
        >
            <span class="text-decoration-underline">
                {{ snack.message }}
            </span>
            <br />
            <span>
                {{ getLowerMessage }}
            </span>
        </div>
    </v-snackbar>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    name: 'trimoz-new-snackbar',
    data() {
        return {
            show: false,
        };
    },
    computed: {
        ...mapGetters({
            snack: 'snackbar/getSnackbar',
        }),
        getLowerMessage() {
            return this.snack.lowerMessage !== undefined ? this.snack.lowerMessage : '';
        },
    },
    watch: {
        snack: {
            handler() {
                this.show = true;
            },
            deep: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.largerSnackBar {
    font-size: 20px;
}
.normalSnackBar {
    font-size: 15px;
}
.v-btn {
    min-width: 0;
}
.v-btn__content {
    padding: 0;
}
.v-snack__content {
    padding: 0;
}
</style>
